import React from 'react'
import styled from 'styled-components'

import { CustomerInvoiceFragment } from '../../../../../../graphql/camel'
import { monthDayYear } from '../../../../../../utils/dateTools'
import { formatAsCurrencyOrZero } from '../../../../../../utils/priceTools'
import ShippingAndBilling from '../ShippingAndBilling'
import * as Styled from './styled'

export interface InvoiceDetailsProps {
  className?: string
  invoice: CustomerInvoiceFragment
}

const InvoiceDetails: React.FC<InvoiceDetailsProps> = ({ className, invoice }) => {
  return (
    <div className={className}>
      <h3 className="small-h3">Invoice Details</h3>
      <Styled.FieldValuesSection>
        <Styled.InvoiceDetail>
          <Styled.FieldType>Invoice Total: </Styled.FieldType>
          <Styled.FieldValuePrimary>
            {formatAsCurrencyOrZero({ amount: invoice.total })}
          </Styled.FieldValuePrimary>
        </Styled.InvoiceDetail>
        {!!invoice.date && (
          <Styled.InvoiceDetail>
            <Styled.FieldType>Invoice Date: </Styled.FieldType>
            <Styled.FieldValue>
              {monthDayYear(invoice.date, 'EEEE, MMMM do yyyy')} ({monthDayYear(invoice.date)})
            </Styled.FieldValue>
          </Styled.InvoiceDetail>
        )}
        {!!invoice.dueDate && (
          <Styled.InvoiceDetail>
            <Styled.FieldType>Due Date: </Styled.FieldType>
            <Styled.FieldValue>
              {monthDayYear(invoice.dueDate, 'EEEE, MMMM do yyyy')} ({monthDayYear(invoice.dueDate)}
              )
            </Styled.FieldValue>
          </Styled.InvoiceDetail>
        )}
        {!!invoice.createdFromOrder && (
          <Styled.InvoiceDetail>
            <Styled.FieldType>Created From: </Styled.FieldType>
            <Styled.FieldValue>Order #{invoice.createdFromOrder.orderNumber}</Styled.FieldValue>
          </Styled.InvoiceDetail>
        )}
        {invoice.otherRefNum && (
          <Styled.InvoiceDetail>
            <Styled.FieldType>PO #: </Styled.FieldType>
            <Styled.FieldValue>{invoice.otherRefNum}</Styled.FieldValue>
          </Styled.InvoiceDetail>
        )}
      </Styled.FieldValuesSection>
      <Styled.HorizontalRule />
      {(invoice.shippingAddress || invoice.billingAddress) && (
        <>
          <ShippingAndBilling invoice={invoice} />
          <Styled.HorizontalRule />
        </>
      )}
    </div>
  )
}

const StyledInvoiceDetails = styled(InvoiceDetails)``

export { StyledInvoiceDetails as InvoiceDetails }
